import React from 'react';
import { Box, CircularProgress } from '@mui/material';

/**
 * Fallback for the app-root `<React.Suspense>` in App.tsx, which wraps every
 * `React.lazy()` route (Login included). It fires on the *first* load of any
 * route's JS chunk — cold app launch, a fresh/incognito browser session, or
 * navigating to a route visited for the first time this session — not on data
 * fetches, which each page already handles with its own loading state.
 *
 * This used to reuse GlobalComponents/KenLoader (a `position:fixed;inset:0`,
 * 30%-black-dim modal with a Lottie file literally named "Paperplane"), built
 * for "an action is in progress, block interaction" cases like a form submit.
 * Reused here it fired on every cold load on every platform — including the
 * public Login page, before anything else had rendered — and read as a
 * flash/glitch rather than a loading state. A plain, undimmed spinner is the
 * correct weight for "this route's code is still downloading."
 */
const AppBootLoader: React.FC = () => (
  <Box
    sx={{
      position: 'fixed',
      inset: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: '#ffffff',
    }}
  >
    <CircularProgress sx={{ color: '#604797' }} />
  </Box>
);

export default AppBootLoader;
